import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {
  setList,
  detailRequest,
  detailSuccess,
  detailFailure,
  listRequest,
  listSuccess,
  listFailure,
  updateRequest,
  updateSuccess,
  updateFailure,
} from './genericReducers'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  setShopifyProducts: ['list'],

  shopifyProductDetailRequest: ['id', 'showProductData'],
  shopifyProductDetailSuccess: ['detailData'],
  shopifyProductDetailFailure: ['detailError'],

  shopifyProductListRequest: ['params'],
  shopifyProductListSuccess: ['list'],
  shopifyProductListFailure: ['listError'],

  activatedProductListRequest: ['params', 'activatedListOffset', 'callback'],
  activatedProductListSuccess: ['activatedList'],
  activatedProductListFailure: ['activatedListError'],

  shopifyProductsUpdateRequest: ['params', 'callback'],
  shopifyProductsUpdateSuccess: ['data'],
  shopifyProductsUpdateFailure: ['error'],

  activatedFixedApptProductListRequest: [],
  activatedFixedApptProductListSuccess: ['activatedFixedApptList'],
  activatedFixedApptProductListFailure: ['activatedFixedApptListError'],

  shopifyProductsSearchRequest: ['params', 'callback'],
  createShopifyProduct: ['params', 'callback'],

  shopifyProductKeyReset: ['key'],
})

export const ShopifyProductTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: [],
  listFetching: null,
  listError: null,

  detailData: {},
  detailError: null,
  detailFetching: false,

  updateData: {},
  updateError: null,
  updateFetching: false,

  activatedList: [],
  activatedListFetching: null,
  activatedListError: null,
  activatedListOffset: 0,

  activatedFixedApptList: [],
  activatedFixedApptListFetching: null,
  activatedFixedApptListError: null,
})

/* ------------- Reducers ------------- */

export const reset = (state) => state.merge(INITIAL_STATE)

export const activatedListRequest = (
  state,
  { listParams, activatedListOffset }
) => {
  return state.merge({
    listParams,
    activatedListFetching: true,
    activatedListError: null,
    activatedListOffset: activatedListOffset || 0,
  })
}

export const activatedListSuccess = (state, { activatedList }) => {
  return state.merge({
    activatedList,
    activatedListFetching: false,
  })
}

export const activatedListFailure = (state, { activatedListError }) => {
  return state.merge({ activatedListError, activatedListFetching: false })
}

export const activatedFixedApptListRequest = (state, { listParams }) => {
  return state.merge({
    listParams,
    activatedFixedApptListFetching: true,
    activatedFixedApptListError: null,
  })
}

export const activatedFixedApptListSuccess = (
  state,
  { activatedFixedApptList }
) => {
  return state.merge({
    activatedFixedApptList,
    activatedFixedApptListFetching: false,
  })
}

export const activatedFixedApptListFailure = (
  state,
  { activatedFixedApptListError }
) => {
  return state.merge({
    activatedFixedApptListError,
    activatedFixedApptListFetching: false,
  })
}

export const resetBasedOnKey = (state, { key }) => {
  return state.merge({
    [key]: INITIAL_STATE[key],
  })
}

/* ------------- Selectors ------------- */

export const ShopifyProductSelectors = {
  products: (state) => state.shopifyProduct.list,
  activatedListOffset: (state) => state.shopifyProduct.activatedListOffset,
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_SHOPIFY_PRODUCTS]: setList,

  [Types.SHOPIFY_PRODUCT_DETAIL_REQUEST]: detailRequest,
  [Types.SHOPIFY_PRODUCT_DETAIL_SUCCESS]: detailSuccess,
  [Types.SHOPIFY_PRODUCT_DETAIL_FAILURE]: detailFailure,

  [Types.SHOPIFY_PRODUCTS_UPDATE_REQUEST]: updateRequest,
  [Types.SHOPIFY_PRODUCTS_UPDATE_SUCCESS]: updateSuccess,
  [Types.SHOPIFY_PRODUCTS_UPDATE_FAILURE]: updateFailure,

  [Types.SHOPIFY_PRODUCT_LIST_REQUEST]: listRequest,
  [Types.SHOPIFY_PRODUCT_LIST_SUCCESS]: listSuccess,
  [Types.SHOPIFY_PRODUCT_LIST_FAILURE]: listFailure,

  [Types.ACTIVATED_PRODUCT_LIST_REQUEST]: activatedListRequest,
  [Types.ACTIVATED_PRODUCT_LIST_SUCCESS]: activatedListSuccess,
  [Types.ACTIVATED_PRODUCT_LIST_FAILURE]: activatedListFailure,

  [Types.ACTIVATED_FIXED_APPT_PRODUCT_LIST_REQUEST]:
    activatedFixedApptListRequest,
  [Types.ACTIVATED_FIXED_APPT_PRODUCT_LIST_SUCCESS]:
    activatedFixedApptListSuccess,
  [Types.ACTIVATED_FIXED_APPT_PRODUCT_LIST_FAILURE]:
    activatedFixedApptListFailure,

  [Types.SHOPIFY_PRODUCT_KEY_RESET]: resetBasedOnKey,
})
